export const PRE_CHECKOUT_EN = {
  preCheckoutTitle: 'Complete Your Purchase',
  preCheckoutSubtitle: 'One more step to access Newsrooms AI',
  preCheckoutPaymentPrompt: 'Click the button below to proceed to our secure payment page',
  preCheckoutProceedButton: 'Proceed to Checkout',
  preCheckoutLogoutButton: 'Logout',
  preCheckoutSecurePayment: 'Secure payment processing',

  // Billing toggle
  checkoutMonthly: 'Monthly',
  checkoutAnnual: 'Annual',

  // Subscription change preview (existing subscribers)
  checkoutSubscriptionChangePreview: 'Subscription change preview',
  checkoutCompareBeforeSubmit: 'Compare current contract and pending updates before you submit.',
  checkoutLivePreview: 'Live preview',
  checkoutCurrentSubscription: 'Current subscription',
  checkoutPlan: 'Plan',
  checkoutSeats: 'Seats',
  checkoutRecurring: 'Recurring',
  checkoutPerMonth: '/ month',
  checkoutNextRenewal: 'Next renewal',
  checkoutActiveByTier: 'Active now by tier',
  checkoutSeatSingular: 'seat',
  checkoutSeatPlural: 'seats',
  checkoutNoSeatMixData: 'No active seat mix data available.',
  checkoutScheduledAtRenewal: 'Scheduled at renewal',
  checkoutEffectiveDate: 'Effective {date}.',
  checkoutEffectiveNextRenewal: 'Effective next renewal.',
  checkoutPendingChanges: 'Pending changes',
  checkoutNoPendingChanges: 'No pending changes.',
  checkoutUpdateStatus: 'Update status',

  // Products
  checkoutNoProducts: 'No products available.',
  checkoutNotAvailableForPeriod: 'Not available for this period',
  checkoutAddSeat: 'Add seat',
  checkoutSeatsSingular: 'Seat',
  checkoutSeatsPlural: 'Seats',
  checkoutSelectSeats: 'Select seats above to continue',
  checkoutPerYear: '/ year',

  // Billing impact
  checkoutSelectToPreview: 'Select products and seats to preview billing impact.',
  checkoutNoChangeSelected: 'No subscription change selected yet.',
  checkoutUpgradeImpact: 'Upgrade impact',
  checkoutDowngradeImpact: 'Downgrade impact',
  checkoutMixedChangeImpact: 'Mixed change impact',
  checkoutBillingImpact: 'Billing impact',
  checkoutNoBillingDelta: 'No billing delta',
  checkoutImmediateCharge: 'Immediate charge possible',
  checkoutEffectiveNextRenewalBadge: 'Effective next renewal',
  checkoutUpNowDownRenewal: 'Up now, down at renewal',

  // Billing impact lines
  checkoutAdjustSeats: 'Adjust seats/products above to see how this update affects billing.',
  checkoutScheduledRenewalExists: 'You already have a scheduled renewal configuration.',
  checkoutScheduledSeatsBillable: 'Scheduled seats become billable on {date}.',
  checkoutScheduledSeatsBillableNextRenewal:
    'Scheduled seats become billable on the next renewal date.',
  checkoutAmendPendingRenewal:
    'Adjust selections only if you want to amend that pending renewal state.',
  checkoutNoChangeSameSetup:
    'Current and selected subscription setup are the same. No billing mutation will be sent.',
  checkoutUpgradeImmediate:
    'Increased seats/products apply immediately when you submit this update and will be billed automatically.',
  checkoutUpgradeProration: 'Stripe can invoice prorated upgrade charges right away.',
  checkoutUpgradeReductions:
    'If this request also contains reductions, those reduced seats/products are deferred to renewal.',
  checkoutRenewalDateStays: 'Your renewal date stays {date}.',
  checkoutRenewalDateAnchored:
    'Your renewal date stays anchored to the current Stripe subscription cycle.',
  checkoutFutureRecurring: 'Future recurring billing is expected to be {amount}.',
  checkoutDowngradeScheduled:
    'Submitting this update schedules the plan/seat reduction for the next renewal date.',
  checkoutDowngradeActiveTillEnd:
    'Current seats/features remain active until the current billing period ends.',
  checkoutDowngradeTakesEffect: 'The downgrade takes effect on {date}.',
  checkoutDowngradeNoCharge:
    'No immediate downgrade charge is created when scheduling this period-end reduction.',
  checkoutMixedIncreaseImmediate: 'Increases apply immediately after submit.',
  checkoutMixedDecreaseAtRenewal:
    'Any decreases stay active until renewal, then step down at period end.',
  checkoutMixedDowngradeEffect: 'Downgrade portions take effect on {date}.',
  checkoutMixedProration: 'Stripe may charge immediate proration for upgrade portions only.',
  checkoutMixedTargetRecurring: 'Target recurring billing after this change: {amount}.',

  // Change summary
  checkoutSelection: 'Selection',
  checkoutNoPendingSelection: 'No pending seat selection yet.',
  checkoutPlanUnchanged: '(unchanged)',
  checkoutPlanMix: 'Plan mix',
  checkoutNoSeatChange: '(no seat change)',
  checkoutRecurringLabel: 'Recurring',
  checkoutIncrease: 'Increase',
  checkoutDecrease: 'Decrease',
  checkoutInfo: 'Info',

  // Webhook sync
  checkoutSyncingWithStripe: 'Syncing with Stripe',
  checkoutWebhookSynced: 'Webhook synced',
  checkoutScheduledAtRenewalBadge: 'Scheduled at renewal',
  checkoutSyncPending: 'Sync still pending',
  checkoutSyncWaiting: 'Waiting for Stripe webhook confirmation ({current}/{max}).',
  checkoutSyncConfirmed: 'Subscription update is confirmed in your organisation snapshot.',
  checkoutSyncScheduledMessage:
    'Downgrade-only updates are scheduled for renewal; current seats/features stay active until then.',
  checkoutSyncTimeoutMessage:
    'Update submitted, but webhook sync is still pending. You can refresh in a moment to verify.',

  // Submit
  checkoutApplyChanges: 'Apply billable subscription changes',
  checkoutSelectOneSeat:
    'Please select at least one product available for the current billing period.',
  checkoutOnlyAdmins: 'Only organisation admins can manage subscription seats.',
  checkoutUpdateSubmitted:
    'Subscription update submitted. Changes will be reflected after Stripe webhook sync.',
  checkoutUpdateSynced: 'Subscription update synced from Stripe webhook.',
  checkoutFailedUpdate: 'Failed to update subscription. Please try again.',
  checkoutFailedCheckout: 'Failed to create checkout session. Please try again.',
  checkoutNoRedirectUrl: 'Checkout session created but no redirect URL was returned.',
  checkoutLoadFailed: 'Failed to load products. Please refresh.',
  checkoutSeatsRemovedPeriod:
    'Some selected seats were removed because those products are unavailable for the selected billing period.',

  // Price labels
  checkoutPerSeatPerMonth: '/ seat / mo',
  checkoutBilledAnnually: '/ year billed annually',
  checkoutPerYearLabel: '/ year (about {monthly} / month)',
  checkoutPerMonthLabel: '/ month',
  checkoutUnknown: 'Unknown',
  checkoutMixedSubscription: 'Mixed subscription',
  checkoutPricesExclVat: 'All prices excl. VAT'
}

export const PRE_CHECKOUT_DE = {
  preCheckoutTitle: 'Kauf abschließen',
  preCheckoutSubtitle: 'Noch ein Schritt, um auf Newsrooms AI zuzugreifen',
  preCheckoutPaymentPrompt:
    'Klicken Sie auf die Schaltfläche unten, um zur Zahlungsseite zu gelangen',
  preCheckoutProceedButton: 'Zur Kasse gehen',
  preCheckoutLogoutButton: 'Abmelden',
  preCheckoutSecurePayment: 'Sichere Zahlung',

  // Billing toggle
  checkoutMonthly: 'Monatlich',
  checkoutAnnual: 'Jährlich',

  // Subscription change preview (existing subscribers)
  checkoutSubscriptionChangePreview: 'Vorschau der Abonnementänderung',
  checkoutCompareBeforeSubmit:
    'Vergleichen Sie den aktuellen Vertrag und ausstehende Änderungen, bevor Sie absenden.',
  checkoutLivePreview: 'Live-Vorschau',
  checkoutCurrentSubscription: 'Aktuelles Abonnement',
  checkoutPlan: 'Tarif',
  checkoutSeats: 'Plätze',
  checkoutRecurring: 'Wiederkehrend',
  checkoutPerMonth: '/ Monat',
  checkoutNextRenewal: 'Nächste Verlängerung',
  checkoutActiveByTier: 'Aktuell aktiv nach Stufe',
  checkoutSeatSingular: 'Platz',
  checkoutSeatPlural: 'Plätze',
  checkoutNoSeatMixData: 'Keine aktiven Platzdaten verfügbar.',
  checkoutScheduledAtRenewal: 'Geplant bei Verlängerung',
  checkoutEffectiveDate: 'Wirksam ab {date}.',
  checkoutEffectiveNextRenewal: 'Wirksam ab nächster Verlängerung.',
  checkoutPendingChanges: 'Ausstehende Änderungen',
  checkoutNoPendingChanges: 'Keine ausstehenden Änderungen.',
  checkoutUpdateStatus: 'Aktualisierungsstatus',

  // Products
  checkoutNoProducts: 'Keine Produkte verfügbar.',
  checkoutNotAvailableForPeriod: 'Für diesen Zeitraum nicht verfügbar',
  checkoutAddSeat: 'Platz hinzufügen',
  checkoutSeatsSingular: 'Platz',
  checkoutSeatsPlural: 'Plätze',
  checkoutSelectSeats: 'Wählen Sie oben Plätze aus, um fortzufahren',
  checkoutPerYear: '/ Jahr',

  // Billing impact
  checkoutSelectToPreview: 'Wählen Sie Produkte und Plätze, um die Abrechnungsauswirkung zu sehen.',
  checkoutNoChangeSelected: 'Noch keine Abonnementänderung ausgewählt.',
  checkoutUpgradeImpact: 'Upgrade-Auswirkung',
  checkoutDowngradeImpact: 'Downgrade-Auswirkung',
  checkoutMixedChangeImpact: 'Gemischte Änderungsauswirkung',
  checkoutBillingImpact: 'Abrechnungsauswirkung',
  checkoutNoBillingDelta: 'Keine Abrechnungsänderung',
  checkoutImmediateCharge: 'Sofortige Belastung möglich',
  checkoutEffectiveNextRenewalBadge: 'Wirksam bei nächster Verlängerung',
  checkoutUpNowDownRenewal: 'Sofort hoch, bei Verlängerung runter',

  // Billing impact lines
  checkoutAdjustSeats:
    'Passen Sie Plätze/Produkte oben an, um die Auswirkung auf die Abrechnung zu sehen.',
  checkoutScheduledRenewalExists: 'Sie haben bereits eine geplante Verlängerungskonfiguration.',
  checkoutScheduledSeatsBillable: 'Geplante Plätze werden am {date} berechnet.',
  checkoutScheduledSeatsBillableNextRenewal:
    'Geplante Plätze werden zum nächsten Verlängerungsdatum berechnet.',
  checkoutAmendPendingRenewal:
    'Passen Sie die Auswahl nur an, wenn Sie den ausstehenden Verlängerungsstatus ändern möchten.',
  checkoutNoChangeSameSetup:
    'Aktuelles und ausgewähltes Abonnement sind identisch. Es wird keine Abrechnungsänderung gesendet.',
  checkoutUpgradeImmediate:
    'Erhöhte Plätze/Produkte werden sofort nach dem Absenden wirksam und automatisch in Rechnung gestellt.',
  checkoutUpgradeProration: 'Stripe kann anteilige Upgrade-Kosten sofort in Rechnung stellen.',
  checkoutUpgradeReductions:
    'Falls diese Anfrage auch Reduzierungen enthält, werden diese auf die Verlängerung verschoben.',
  checkoutRenewalDateStays: 'Ihr Verlängerungsdatum bleibt der {date}.',
  checkoutRenewalDateAnchored:
    'Ihr Verlängerungsdatum bleibt am aktuellen Stripe-Abrechnungszyklus verankert.',
  checkoutFutureRecurring:
    'Zukünftige wiederkehrende Abrechnung wird voraussichtlich {amount} betragen.',
  checkoutDowngradeScheduled:
    'Das Absenden dieser Aktualisierung plant die Tarif-/Platzreduzierung für das nächste Verlängerungsdatum.',
  checkoutDowngradeActiveTillEnd:
    'Aktuelle Plätze/Funktionen bleiben bis zum Ende des Abrechnungszeitraums aktiv.',
  checkoutDowngradeTakesEffect: 'Das Downgrade wird am {date} wirksam.',
  checkoutDowngradeNoCharge:
    'Beim Planen dieser Reduzierung zum Periodenende wird keine sofortige Belastung erstellt.',
  checkoutMixedIncreaseImmediate: 'Erhöhungen werden sofort nach dem Absenden wirksam.',
  checkoutMixedDecreaseAtRenewal:
    'Reduzierungen bleiben bis zur Verlängerung aktiv und werden dann herabgesetzt.',
  checkoutMixedDowngradeEffect: 'Downgrade-Anteile werden am {date} wirksam.',
  checkoutMixedProration:
    'Stripe berechnet möglicherweise sofortige anteilige Kosten nur für Upgrade-Anteile.',
  checkoutMixedTargetRecurring: 'Wiederkehrende Zielabrechnung nach dieser Änderung: {amount}.',

  // Change summary
  checkoutSelection: 'Auswahl',
  checkoutNoPendingSelection: 'Noch keine Platzauswahl getroffen.',
  checkoutPlanUnchanged: '(unverändert)',
  checkoutPlanMix: 'Tarifmix',
  checkoutNoSeatChange: '(keine Platzänderung)',
  checkoutRecurringLabel: 'Wiederkehrend',
  checkoutIncrease: 'Erhöhung',
  checkoutDecrease: 'Reduzierung',
  checkoutInfo: 'Info',

  // Webhook sync
  checkoutSyncingWithStripe: 'Synchronisierung mit Stripe',
  checkoutWebhookSynced: 'Webhook synchronisiert',
  checkoutScheduledAtRenewalBadge: 'Geplant bei Verlängerung',
  checkoutSyncPending: 'Synchronisierung ausstehend',
  checkoutSyncWaiting: 'Warten auf Stripe-Webhook-Bestätigung ({current}/{max}).',
  checkoutSyncConfirmed: 'Abonnement-Aktualisierung ist in Ihrem Organisationsprofil bestätigt.',
  checkoutSyncScheduledMessage:
    'Downgrade-Änderungen werden bei Verlängerung wirksam; aktuelle Plätze/Funktionen bleiben bis dahin aktiv.',
  checkoutSyncTimeoutMessage:
    'Aktualisierung gesendet, aber Webhook-Synchronisierung steht noch aus. Aktualisieren Sie die Seite in einem Moment zur Überprüfung.',

  // Submit
  checkoutApplyChanges: 'Zahlungspflichtige Abonnementänderungen anwenden',
  checkoutSelectOneSeat:
    'Bitte wählen Sie mindestens ein Produkt, das für den aktuellen Abrechnungszeitraum verfügbar ist.',
  checkoutOnlyAdmins: 'Nur Organisations-Administratoren können Abonnementplätze verwalten.',
  checkoutUpdateSubmitted:
    'Abonnement-Aktualisierung gesendet. Änderungen werden nach der Stripe-Webhook-Synchronisierung angezeigt.',
  checkoutUpdateSynced: 'Abonnement-Aktualisierung über Stripe-Webhook synchronisiert.',
  checkoutFailedUpdate: 'Abonnement-Aktualisierung fehlgeschlagen. Bitte versuchen Sie es erneut.',
  checkoutFailedCheckout:
    'Checkout-Sitzung konnte nicht erstellt werden. Bitte versuchen Sie es erneut.',
  checkoutNoRedirectUrl: 'Checkout-Sitzung erstellt, aber keine Weiterleitungs-URL erhalten.',
  checkoutLoadFailed: 'Produkte konnten nicht geladen werden. Bitte aktualisieren Sie die Seite.',
  checkoutSeatsRemovedPeriod:
    'Einige ausgewählte Plätze wurden entfernt, da diese Produkte für den ausgewählten Abrechnungszeitraum nicht verfügbar sind.',

  // Price labels
  checkoutPerSeatPerMonth: '/ Platz / Monat',
  checkoutBilledAnnually: '/ Jahr (jährliche Abrechnung)',
  checkoutPerYearLabel: '/ Jahr (ca. {monthly} / Monat)',
  checkoutPerMonthLabel: '/ Monat',
  checkoutUnknown: 'Unbekannt',
  checkoutMixedSubscription: 'Gemischtes Abonnement',
  checkoutPricesExclVat: 'Alle Preise zzgl. USt.'
}
